export default __webpack_public_path__ + "static/media/jan1.4403935a.jpg";